document.addEventListener('DOMContentLoaded', function() {
  var selectTriggers = document.querySelectorAll('.custom-select-trigger');
  var fileInput = document.getElementById('feedback-file');
  var fileListContainer = document.getElementById('file-list');
  var fileArray = [];
  var feedbackForm = document.getElementById('feedback-form');
  var floatingTab = document.getElementById('floating-tab');
  var closeButton = document.getElementById('feedback-form-close');

  // Select the open-popup-button element
  var openPopupButton = document.querySelector('.open-popup-button');

  // Dropdown functionality
  selectTriggers.forEach(trigger => {
    trigger.addEventListener('click', function() {
      var selectContainer = this.closest('.custom-select');
      var selectOptions = selectContainer.querySelector('.custom-select-options');
      
      if (selectOptions.classList.contains('open')) {
        selectOptions.classList.remove('open');
      } else {
        document.querySelectorAll('.custom-select-options').forEach(options => {
          options.classList.remove('open');
        });
        selectOptions.classList.add('open');
      }
    });
  });

  // Handle option click
  document.querySelectorAll('.custom-select-option').forEach(option => {
    option.addEventListener('click', function() {
      var value = this.getAttribute('data-value');
      var selectContainer = this.closest('.custom-select');
      var selectTrigger = selectContainer.querySelector('.custom-select-trigger');
      var feedbackTypeInput = document.getElementById('feedback-type');
      
      if (feedbackTypeInput) {
        feedbackTypeInput.value = value; // Update hidden input value
      } else {
        console.error('Feedback type input not found in the DOM');
      }
  
      // Update the trigger text with the selected option
      selectTrigger.textContent = this.textContent;
      
      // Remove the open class to hide options
      selectContainer.querySelector('.custom-select-options').classList.remove('open');
    });
  });

  // Close dropdown if clicked outside
  document.addEventListener('click', function(event) {
    if (!event.target.closest('.custom-select')) {
      document.querySelectorAll('.custom-select-options').forEach(options => {
        options.classList.remove('open');
      });
    }
  });

  // File input functionality
  function updateFileList() {
    fileListContainer.innerHTML = ''; // Clear the file list container
  
    fileArray.forEach((file, index) => {
      var fileItem = document.createElement('div');
      fileItem.className = 'file-item';
      fileItem.textContent = file.name;
  
      var removeButton = document.createElement('button');
      removeButton.className = 'remove-file';
      removeButton.textContent = 'x';
  
      removeButton.addEventListener('click', function(event) {
        event.stopPropagation(); // Prevent the click from bubbling up
  
        fileArray.splice(index, 1); // Use index to correctly remove the item
        updateFileList(); // Update the file list display
  
        updateFileInput();
        updateFileLabel();
      });
  
      fileItem.appendChild(removeButton);
      fileListContainer.appendChild(fileItem);
    });
  
    updateFileLabel();
  }

  function updateFileLabel() {
    var fileCount = fileArray.length;
    var label = document.querySelector('.custom-file-upload span'); // Ensure correct span is targeted
    if (fileCount > 0) {
      label.textContent = `${fileCount} file(s) selected`;
    } else {
      label.textContent = 'Upload supporting documents';
    }
  }

  function updateFileInput() {
    var dataTransfer = new DataTransfer();
    fileArray.forEach(file => dataTransfer.items.add(file));
    fileInput.files = dataTransfer.files;
  }

  function resetFileInput() {
    fileArray = [];
    updateFileList();
    updateFileLabel();
    
    var newFileInput = fileInput.cloneNode(true);
    fileInput.parentNode.replaceChild(newFileInput, fileInput);
    fileInput = newFileInput;
  
    fileInput.addEventListener('change', handleFileInputChange);
  }

  function handleFileInputChange() {
    Array.from(fileInput.files).forEach(file => {
      if (!fileArray.some(f => f.name === file.name)) {
        fileArray.push(file);
      }
    });
  
    updateFileList();
    fileInput.value = ''; 
  }

  // Initial event listener attachment
  fileInput.addEventListener('change', handleFileInputChange);

  // Form handling
  // Record which page the feedback came from (added 28 Oct 2026)
  function fillPageFields() {
    var u = document.getElementById('feedback-page-url');
    var t = document.getElementById('feedback-page-title');
    if (u) u.value = window.location.href;
    if (t) t.value = document.title;
  }

  // 'Report a problem with this page' link on product pages (added 28 Oct 2026)
  window.reportProblemWithPage = function (event) {
    if (event) event.preventDefault();
    var type = document.getElementById('feedback-type');
    var trigger = document.querySelector('.custom-select-trigger');
    var label = 'Website (Bug report, usability, feature request)';
    if (type) type.value = label;
    if (trigger) trigger.textContent = label;
    var subject = document.getElementById('feedback-subject');
    if (subject && !subject.value) subject.value = 'Problem with page: ' + document.title;
    if (!feedbackForm.classList.contains('open')) toggleFeedbackForm(event);
    else fillPageFields();
  };

  function toggleFeedbackForm(event) {
    fillPageFields();
    if (event) {
      event.preventDefault();
    }
    var isOpen = feedbackForm.classList.contains('open');

    if (isOpen) {
      // Close the form
      feedbackForm.classList.remove('open');
      floatingTab.style.transform = 'translateX(0)';
      
      // Show the open-popup-button
      if (openPopupButton) {
        openPopupButton.style.opacity = '1'; // Set opacity back to 1
      }

      setTimeout(() => {
        feedbackForm.style.display = 'none';
        if (window.innerWidth < 750) {
          floatingTab.style.display = 'block'; // Ensure tab is visible on smaller screens
        }
      }, 300);
    } else {
      // Open the form
      feedbackForm.style.display = 'block';
      setTimeout(() => {
        feedbackForm.classList.add('open');
        floatingTab.style.transform = 'translateX(-60rem)';
        
        // Hide the open-popup-button
        if (openPopupButton) {
          openPopupButton.style.opacity = '0'; // Set opacity to 0
        }

        if (window.innerWidth < 750) {
          floatingTab.style.display = 'none'; // Hide tab on smaller screens
        }
      }, 10);
    }
  }

  // Ensure toggleFeedbackForm is globally accessible
  window.toggleFeedbackForm = toggleFeedbackForm;

  // Attach click event to #floating-tab to toggle feedback form
  floatingTab.addEventListener('click', function(event) {
    toggleFeedbackForm(event); // Pass event to toggleFeedbackForm
  });

  closeButton.addEventListener('click', function(event) {
    toggleFeedbackForm(event); // Use the same toggle function to close the form
  });

  document.addEventListener('click', function(event) {
    var isFormOpen = feedbackForm.classList.contains('open');

    if (isFormOpen && !feedbackForm.contains(event.target) && !floatingTab.contains(event.target)) {
      toggleFeedbackForm(event); // Use the same toggle function to close the form
    }
  });

  // 28 Oct 2026: visible result. Shopify holds the submit for a few seconds (hCaptcha), POSTs, then reloads the page with the result inside this
  // closed panel. Show 'Sending', and after the reload reopen the panel on the thank-you (or error) state.
  var contactForm = document.getElementById('ContactForm');
  var submitBtn = document.getElementById('feedback-form-submit');
  var sendTimer = null;
  if (contactForm && submitBtn) {
    contactForm.addEventListener('submit', function() {
      submitBtn.classList.add('is-sending');
      submitBtn.setAttribute('aria-busy', 'true');
      submitBtn.textContent = 'Sending... please wait';
      var old = contactForm.querySelector('.feedback-note');
      if (old) old.remove();
      clearTimeout(sendTimer);
      sendTimer = setTimeout(function() {
        submitBtn.classList.remove('is-sending');
        submitBtn.removeAttribute('aria-busy');
        submitBtn.textContent = 'Submit Feedback';
        var n = document.createElement('p');
        n.className = 'feedback-note';
        n.setAttribute('role', 'alert');
        n.textContent = 'This is taking longer than expected. Please press Submit Feedback again, or email us if it keeps happening.';
        submitBtn.parentNode.appendChild(n);
      }, 30000);
    });
  }
  var stateEl = document.getElementById('feedback-state');
  var fbState = stateEl ? stateEl.getAttribute('data-state') : '';
  if (fbState === 'success' || fbState === 'error') {
    if (fbState === 'success') feedbackForm.classList.add('is-success');
    setTimeout(function() {
      if (!feedbackForm.classList.contains('open')) toggleFeedbackForm();
      var target = feedbackForm.querySelector('.feedback-thanks, .form-status');
      if (target && target.focus) setTimeout(function() { target.focus(); }, 350);
      try {
        var u = new URL(window.location.href);
        u.searchParams.delete('contact_posted');
        u.hash = '';
        window.history.replaceState(null, '', u.pathname + (u.search || ''));
      } catch (e) {}
    }, 500);
  }

  // Handle screen size changes
  window.addEventListener('resize', function() {
    if (window.innerWidth >= 750) {
      floatingTab.style.display = 'block'; // Ensure tab is visible on larger screens
    } else if (feedbackForm.classList.contains('open')) {
      floatingTab.style.display = 'none'; // Hide tab when form is open on smaller screens
    }
  });
});
